

















import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: "Validator",
  components: {}
})
export default class Validator extends Vue {
  @Prop({
    required: true
  })
  private widget!: App.WebForm.Widget;
}
